const index = () => import('./Index');

//
export default {
  routes: [
    {
      path: '/smes/triple/v2021/index',
      name: 'smes_triple_v2021_index',
      component: index,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/smes/triple/v2021/router.js